module.exports = __webpack_public_path__ + "static/media/RTRS_Bosnia_Herzegovina.ba4bbacd.png";